import { z } from 'zod';
import { uuid } from './common.js';
export const passwordSchema = z
    .string()
    .min(10, 'Passwort muss mindestens 10 Zeichen haben')
    .max(200);
export const emailSchema = z.string().email().max(320).transform((s) => s.toLowerCase());
export const loginRequest = z.object({
    email: emailSchema,
    password: z.string().min(1).max(200),
});
export const passwordForgotRequest = z.object({
    email: emailSchema,
});
export const passwordResetRequest = z.object({
    token: z.string().min(10).max(200),
    password: passwordSchema,
});
/** Self-service "Passwort ändern" from the profile menu — unlike
 * `passwordResetRequest` (token-based, no active session needed), this
 * requires the current password and an active session. */
export const changePasswordRequest = z.object({
    currentPassword: z.string().min(1).max(200),
    newPassword: passwordSchema,
});
/** Auswählbare Startseiten für die Pro-Benutzer-Präferenz (siehe `MeResponse.user.homePage`
 * unten) — bewusst nur die vier Top-Level-Nav-Punkte, keine verschachtelten
 * Verwaltungsseiten. Reihenfolge bestimmt die Anzeige im Auswahlfeld. */
export const HOME_PAGE_OPTIONS = ['dashboard', 'training', 'season', 'calendar'];
/** Self-service "Startseite" (Profilmenü) — welche Seite nach dem Login statt
 * des Dashboards erscheint. `null` setzt auf den Dashboard-Default zurück. */
export const setHomePageRequest = z.object({
    homePage: z.enum(HOME_PAGE_OPTIONS).nullable(),
});
/** Self-service "Vergangene Spiele ausblenden" (Saisonspiele-Seite) — global
 * pro Benutzerkonto, nicht pro Verein, damit die Einstellung auch auf einem
 * anderen Gerät erhalten bleibt. */
export const setHidePastSeasonMatchesRequest = z.object({
    hidePastSeasonMatches: z.boolean(),
});
/** Self-service "Nur meine Mannschaft"/Team-Filter (Saisonspiele-Seite,
 * § Nutzeranfrage) — anders als `setHidePastSeasonMatchesRequest` pro
 * Benutzer UND pro (aktivem) Verein gespeichert, da eine Team-ID nur
 * innerhalb eines Vereins Sinn ergibt (`organization_members`, nicht das
 * globale `users`). */
export const setSeasonMatchFilterRequest = z.object({
    onlyMyTeam: z.boolean(),
    teamIds: z.array(uuid).max(50),
});
export const selectOrganizationRequest = z.object({
    organizationId: uuid,
});
//# sourceMappingURL=auth.js.map